import { render, staticRenderFns } from "./BrowserNotice.vue?vue&type=template&id=6329d496&"
import script from "./BrowserNotice.js?vue&type=script&lang=js&"
export * from "./BrowserNotice.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6329d496')) {
      api.createRecord('6329d496', component.options)
    } else {
      api.reload('6329d496', component.options)
    }
    module.hot.accept("./BrowserNotice.vue?vue&type=template&id=6329d496&", function () {
      api.rerender('6329d496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/BrowserNotice/BrowserNotice.vue"
export default component.exports